import { Box, styled } from '@mui/material';

export const CategoriesWrapperStyled = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
}));
